import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { ApiError, ContactApiError, ContactRequest, ContactResponse } from './contact.models';

@Injectable({ providedIn: 'root' })
export class ContactService {
  private readonly http = inject(HttpClient);
  private readonly contactUrl = `${environment.apiUrl}/api/contact`;

  submit(request: ContactRequest): Observable<ContactResponse> {
    return this.http
      .post<ContactResponse>(this.contactUrl, request)
      .pipe(catchError((error: unknown) => throwError(() => toContactApiError(error))));
  }
}

function toContactApiError(error: unknown): ContactApiError {
  if (!(error instanceof HttpErrorResponse)) return new ContactApiError('server');
  if (error.status === 0) return new ContactApiError('network');
  if (error.status === 429) return new ContactApiError('rate-limit');

  const body = isApiError(error.error) ? error.error : undefined;
  if (body?.error.code === 'VERIFICATION_FAILED') return new ContactApiError('verification');
  if (error.status === 400) return new ContactApiError('validation');

  return new ContactApiError('server');
}

function isApiError(value: unknown): value is ApiError {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<ApiError>;
  return (
    candidate.success === false &&
    typeof candidate.error === 'object' &&
    candidate.error !== null &&
    typeof candidate.error.code === 'string' &&
    typeof candidate.error.message === 'string'
  );
}
